import MasterSettingAgreement36CreatePage from './MasterSettingAgreement36CreatePage';

export default MasterSettingAgreement36CreatePage;